import "./SocialLinkItem.css.ts.vanilla.js";
var p = "_1bp3tx71", a = "_1bp3tx73", i = "_1bp3tx72", n = "_1bp3tx70", o = "_1bp3tx74";
export {
  p as icon,
  a as iconComponent,
  i as iconImage,
  n as linkItem,
  o as visuallyHidden
};
